import React from 'react';

import { Modal } from '@auspost/postmaster-react';

import { setInlineEdd } from 'store/deliveryEstimate/deliveryEstimate.slice';
import { useAppDispatch } from 'store/store';

import AddressLookupModal, { SearchResult } from './CalculatorModals/AddressLookupModal';
import ErrorModal from './CalculatorModals/ErrorModal';
import EstimateResultModal from './CalculatorModals/EstimateResultModal';
import { useInlineEddCalculator } from './hooks/InlineEdd.hooks';
import { INLINE_EDD_EDIT_TEST_ID, INLINE_EDD_TEST_ID } from './InlineEdd.test-ids';

import styles from './InlineEdd.module.scss';

const InlineEdd: React.FC = () => {
  const dispatch = useAppDispatch();
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const [calculateActioned, setCalculateActioned] = React.useState(false);

  const [currentQuery, setCurrentQuery] = React.useState<SearchResult | null>(null);
  const [resultQuery, setResultQuery] = React.useState<SearchResult | null>(null);

  const { isLoading, calculatedDeliveryEstimate, errorType, fetchEstimate } = useInlineEddCalculator();

  React.useEffect(() => {
    if (currentQuery?.postcode) fetchEstimate(currentQuery);
  }, [currentQuery]);

  React.useEffect(() => {
    if (calculatedDeliveryEstimate || errorType) {
      setCalculateActioned(true);
      setResultQuery(currentQuery);
      setCurrentQuery(null);
    }
  }, [calculatedDeliveryEstimate, errorType]);

  // reset modal default address lookup modal
  React.useEffect(() => {
    setCalculateActioned(false);
  }, [isModalOpen]);

  const handleDismissModal = () => {
    setIsModalOpen(false);
    calculatedDeliveryEstimate && dispatch(setInlineEdd(calculatedDeliveryEstimate));
  };
  const displayModal = () => {
    if (!calculateActioned)
      return (
        <AddressLookupModal
          isLoading={isLoading}
          handleCancel={handleDismissModal}
          handleCalculate={(input) => {
            dispatch(setInlineEdd(null));
            setCurrentQuery(input);
          }}
        />
      );
    if (errorType) return <ErrorModal errorType={errorType} handleClose={handleDismissModal} />;
    return (
      <EstimateResultModal
        state={resultQuery?.state || ''}
        postcode={resultQuery?.postcode || ''}
        estimate={calculatedDeliveryEstimate}
        handleClose={handleDismissModal}
      />
    );
  };
  return (
    <>
      {calculatedDeliveryEstimate ? (
        <p className={styles.inlineEddEstimation} data-testid={INLINE_EDD_EDIT_TEST_ID}>
          {resultQuery?.postcode && `To ${resultQuery?.state || ''} ${resultQuery?.postcode} `}
          <button className={styles.editLinkButton} onClick={() => setIsModalOpen(true)}>
            Edit
          </button>
        </p>
      ) : (
        <button
          className={styles.inlineEddButtonLink}
          onClick={() => setIsModalOpen(true)}
          data-testid={INLINE_EDD_TEST_ID}
        >
          Calculate dates now
        </button>
      )}

      <Modal
        isModalShowing={isModalOpen}
        onHide={handleDismissModal}
        modalClassName={styles.inlineEddModal}
        dialogClassName={styles.inlineEddDialog}
        ariaDialogLabel='inline edd modal'
      >
        {displayModal()}
      </Modal>
    </>
  );
};

export default InlineEdd;
